import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@/ui-kit';
import styles from './introB.module.scss';
import { routesApp } from '@/constans/routes';
import { generatePath, useNavigate } from 'react-router-dom';
import { useAuth } from '@/store/useAuth';
import { eventsApi } from '@/api';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { SignUpDesign, useSignUpDesign } from '@/store/useSignUpDesign';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';

export const IntroB: React.FC = () => {
    const { user, emptyFields, getUser, profileWasRemovedError } = useAuth((state) => state);
    const navigate = useNavigate();

    useEffect(() => {
        let path: string | null = null;

        if (
            emptyFields() ||
            profileWasRemovedError
        ) {
            // Ничего не делаем, если есть незаполненные поля
            eventsApi.updateUserEvent('start_screen');
            callYaMetrika('first_screen_loaded', {
                first_screen: 'B'
            });
            return;
        }

        if (getUser()?.state === 'incomplete') {
            // Если пользователь не завершил регистрацию
            path = generateSignUpPath();
        } else {
            // Если пользователь завершил регистрацию
            path = generatePath(routesApp.browse);
        }

        if (path) {
            navigate(path, { replace: true });
        }
    }, [emptyFields, navigate, user]);

    const { isVibrationEnabled } =
        useVibration(state => state);

    const registerClick = () => {
        callYaMetrika('clicked_registration_button');
        navigate(
            generateSignUpPath()
        );
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const {
        design: signUpScreen,
        setDesign
    } =
        useSignUpDesign((state) => state)

    // rt15161: a/b test of sign up
    const generateSignUpPath = () => {
        let design: SignUpDesign =
            signUpScreen
        if (user) {
            setDesign(user?.registration_design)
            design = user?.registration_design
        }
        return generatePath(
            design === 'new_skip_steps' ?
                routesApp.registrationV4
            : design === 'new_photo_last' ?
                routesApp.registrationV3
            : design === 'new' ?
                routesApp.registrationV2
            :
                routesApp.registration,
            { stepNumer: '1' }
        );
    }

    return (
        <section className={styles.intro}>
            <div className={styles.intro__content}>
                <Typography
                    className={styles.intro__Headline}
                    typeColor="white"
                    variant="h1"
                    center>
                    Найди свою вторую половинку
                </Typography>
                <Typography
                    typeColor="white"
                    variant="p"
                    className={styles.intro__text}
                    center
                >
                    Euphora — знакомства для любителей путешествовать
                </Typography>
                <div className={styles.intro__btn}>
                    <Button
                        variant="stretched"
                        typeColor='orange'
                        onClick={registerClick}>
                        Найти свою любовь
                    </Button>
                </div>
                <Typography
                    center
                    className={styles.introFootnote}>
                    Принимаю условия регистрации пользователей.
                </Typography>
                <Typography
                    center
                    className={styles.introFootnote}>
                    Нажимая на кнопку «Найти свою любовь», вы подтверждаете свое согласие с пользовательским соглашением и условиями обработки персональных данных
                </Typography>
            </div>
        </section>
    );
};
